<template>
  <div>
    <span>
      <b-row>
        <b-col lg="6" sm="6">
          <vs-button
            @click="partinoDetay()"
            color="success"
            type="gradient"
            size="small"
            icon="search"
            radius
          ></vs-button>
        </b-col>
        <b-col lg="6" sm="6">
          <vs-button
            @click="kartDetay()"
            color="primary"
            type="gradient"
            size="small"
            icon="edit"
            radius
          ></vs-button>
        </b-col>
      </b-row>
    </span>
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Parti Listesi"
      :hide-footer="true"
    >
      <div>
        <b-row>
          <vue-good-table
            :columns="columnsparti"
            :rows="rowDataparti"
            :rtl="dir"
            max-height="350px"
            :fixed-header="true"
            :row-style-class="rowStyleClassFn"
          >
            <template slot="table-row" slot-scope="props">
              <!-- Column: Name -->
              <div
                v-if="props.column.field === 'TRANSDATE'"
                class="text-nowrap"
              >
                <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
              </div>
            </template>

            <!-- pagination -->
          </vue-good-table>
        </b-row>
      </div>
    </b-modal>
    <StokDetayComponent ref="stokDetay" />
  </div>
</template>
<script>
import StokDetayComponent from "./StokDetayComponent.vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      dir: false,
      rowDataparti: [],
      columnsparti: [
        {
          label: "PARTI NO",
          field: "PARTINO",
        },
        {
          label: "GIRIS",
          field: "GIRIS",
        },
        {
          label: "CIKIS",
          field: "CIKIS",
        },
        {
          label: "KALAN",
          field: "KALAN",
        },
      ],
    };
  },
  components: {
    StokDetayComponent,
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    partinoDetay() {
      this.$refs["modal-primary "].show();
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        STOCKID: this.params.data.STOCKID,
      };
      soap.createClient(url, function (err, client) {
        client.STOCKBAKIYE(args, function (err, result) {
          if (result.STOCKBAKIYEResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.STOCKBAKIYEResult);
            vm.rowDataparti = vm.veriler;
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    kartDetay() {
      this.$refs.stokDetay.stokDetayComponent(this.params.data);
    },
  },
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>